// webapp/src/utils/product_type_utils.js

export const PRODUCT_TYPES = {
  PARENT: 'parent',
  CHILD: 'child',
  SOLO: 'solo',
  // Pseudo parent with no children
  REGULAR: 'regular',
  // Not grouped by parent_asin
  UNKNOWN: 'unknown' // Fallback for unexpected cases
};

/**
 * Determines the type of a product item based on grouping.
 * @param {Object} item - The product item data.
 * @param {string} groupBy - The current grouping key (e.g., 'parent_asin', 'product', 'segment', 'brand').
 * @returns {string} - One of 'parent', 'child', 'solo', 'regular', or 'unknown'.
 */
export function getProductType(item) {
  if (item?.is_child_asin) {
    return PRODUCT_TYPES.CHILD;
  }
  if (!item?.standardized_parent_asin && item?.asin_count === 1) {
    return PRODUCT_TYPES.SOLO;
  }
  // If not a child and not a solo item, it must be a parent (either with children or a parent that isn't a solo item)
  return PRODUCT_TYPES.PARENT;
}